<template>
  <div class="customer-edit">
    <div class="title" v-if="form.id === 0">New Company</div>
    <div class="title" v-else>Edit:&nbsp;{{ form.abbreviation }}</div>
    <table>
      <tr>
        <td colspan="4">&nbsp;</td>
      </tr>
      <!--Public Information-->
      <tr>
        <td colspan="4" style="background:#ddd;font-weight:bold;">Public Information</td>
      </tr>
      <tr>
        <td class="label">Company Name</td>
        <td colspan="3" v-if="user.role_id < 3 || form.name_hide === '0'">
          <el-input v-model="form.name" style="width:500px" :class="[form.name_hide === '0' ? '' : 'hide-input']"></el-input>
          (<el-input v-model="form.name2" style="width:300px" :class="[form.name_hide === '0' ? '' : 'hide-input']"></el-input>)
          <el-checkbox v-model="form.name_hide" true-label="1" false-label="0" v-if="user.role_id < 3">Hide</el-checkbox>
        </td>
      </tr>  
      <tr>
        <td class="label">Abbreviation<span style="color:red">*</span></td>
        <td style="width:450px;"><el-input v-model="form.abbreviation" style="width:150px"></el-input></td>
        <td class="label" rowspan="4">Public Information</td>
        <td rowspan="4"><el-input type="textarea" :rows="6" v-model="form.public_information"></el-input></td>
      </tr>   
      <tr>
        <td class="label">Country<span style="color:red">*</span></td>
        <td>
          <el-select v-model="form.country" filterable @change="changeCountry">
            <el-option v-for="item in countries" :key="item.en" :label="item.en" :value="item.en"></el-option>
          </el-select>
        </td>
      </tr> 
      <tr>
        <td class="label">Country Code</td>
        <td><el-input v-model="form.country_code" style="width:150px"></el-input></td>
      </tr>
      <tr>
        <td class="label">Customer Source<span style="color:red">*</span></td>
        <td>
          <select v-model="form.source">
            <option v-for="item in sourceList" :key="item" :value="item">{{ item }}</option>
          </select>
        </td>
      </tr>
      <!--Sales Information-->
      <tr>
        <td colspan="4">&nbsp;</td>
      </tr>
      <tr>
        <td colspan="4" style="background:#ddd;font-weight:bold;">Sales Information</td>
      </tr>
      <tr>
        <td class="label">Sales 1</td>
        <td>
          <el-select v-model="form.sales_id">
            <el-option v-for="item in salesList" :key="item.id" :label="item.realname" :value="item.id"></el-option>
          </el-select>
        </td>
        <td class="label">Sales 2</td>
        <td>
          <el-select v-model="form.sales2_id">
            <el-option v-for="item in salesList" :key="item.id" :label="item.realname" :value="item.id"></el-option>
          </el-select>
        </td>
      </tr> 
      <tr>
        <td colspan="4">&nbsp;</td>
      </tr>
      <tr>
        <td colspan="4" style="background:#ddd;font-weight:bold;">Customer Class<span style="color:red">*</span></td>
      </tr>
      <tr>
        <td colspan="4" style="padding:4px;">
          <el-checkbox-group v-model="form.classes" @change="classChange">
            <el-checkbox v-for="item in categoryList" :key="item.id" :label="item.id">{{ item.name }}</el-checkbox>
          </el-checkbox-group>
        </td>
      </tr>
      <!--Private Information-->
      <tr>
        <td colspan="4">&nbsp;</td>
      </tr>
      <tr>
        <td colspan="4" style="background:#ddd;font-weight:bold;">Private Information</td>
      </tr>
      <tr>
        <td class="label">Address</td>
        <td><el-input type="textarea" :rows="5" v-model="form.address"></el-input></td>
        <td class="label">Ship Address</td>
        <td><el-input type="textarea" :rows="5" v-model="form.ship_address"></el-input></td>
      </tr> 
      <tr>
        <td class="label">Phone</td>
        <td>
          1.<el-input v-model="form.phone" style="width:140px;"></el-input>
          &nbsp;
          2.<el-input v-model="form.phone_2" style="width:140px;"></el-input>
        </td>
        <td class="label" rowspan="3">Private Information</td>
        <td rowspan="3"><el-input type="textarea" :rows="5" v-model="form.information"></el-input></td>
      </tr> 
      <tr>
        <td class="label">Fax</td>
        <td>
          1.<el-input v-model="form.fax" style="width:140px;"></el-input>
          &nbsp;
          2.<el-input v-model="form.fax_2" style="width:140px;"></el-input>
        </td>
      </tr> 
      <tr>
        <td class="label">Web Page</td>
        <td><el-input v-model="form.web_page"></el-input></td>
      </tr> 
      <tr>
        <td class="label">Email</td>
        <td><el-input v-model="form.email"></el-input></td>
        <td class="label" rowspan="3">Company Note</td>
        <td rowspan="3"><el-input type="textarea" :rows="4" v-model="form.note"></el-input></td>
      </tr> 
      <tr>
        <td class="label">Trade / Factory<span style="color:red">*</span></td>
        <td>
          <select v-model="form.type_1">
            <option label="Trade" value="Trade">Trade</option>
            <option label="Factory" value="Factory">Factory</option>
          </select>
        </td>
      </tr>
      <tr>
        <td class="label">Supplier / Buyer<span style="color:red">*</span></td>
        <td>
          <select v-model="form.type_2">
            <option label="Supplier" value="Supplier">Supplier</option>
            <option label="Buyer" value="Buyer">Buyer</option>
          </select>
        </td>
      </tr>
      <tr v-if="user.role_id < 3">
        <td class="label">Grade</td>
        <td>
          <el-select v-model="form.grade" style="width:70px">
            <el-option label="-2" value="-2"></el-option>
            <el-option label="-1" value="-1"></el-option>
            <el-option label="0" value="0"></el-option>
            <el-option label="1" value="1"></el-option>
            <el-option label="2" value="2"></el-option>
            <el-option label="3" value="3"></el-option>
            <el-option label="4" value="4"></el-option>
            <el-option label="5" value="5"></el-option>
          </el-select>
          <five-star :value="parseInt(form.grade)"></five-star>
        </td>
        <td class="label">Evaluation</td>
        <td>
          <el-input v-model="form.evaluation"></el-input>
        </td>
      </tr>
      <!--Director Remark-->
      <tr>
        <td colspan="4">&nbsp;</td>
      </tr>
      <tr>
        <td colspan="4" style="background:#ddd;font-weight:bold;">Director Remark</td>
      </tr>
      <tr>
        <td class="label">Director Remark</td>
        <td colspan="3">
          <el-input type="textarea" :rows="3" class="hide-input" v-model="form.director_remark"></el-input>
        </td>
      </tr>
      <tr>
        <td colspan="4">&nbsp;</td>
      </tr>
      <tr>
        <td colspan="4" style="text-align:center;padding:6px;">
          <el-button type="primary" @click="save">Save</el-button>
          <el-button @click="cancel">Cancel</el-button>
          <el-button type="danger" @click="del" v-if="user.role_id < 3 && form.id > 0">Delete</el-button>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import FiveStar from './FiveStar.vue'
export default {
  components: {
    FiveStar
  },
  data () {
    return {
      company: {
        id: this.$route.params.id === 'new' ? 0 : parseInt(this.$route.params.id),
        name: ''
      },
      form: {
        id: this.$route.params.id === 'new' ? 0 : parseInt(this.$route.params.id),
        name: '',
        name2: '',
        name_hide: '0',
        abbreviation: '',
        address: '',
        ship_address: '',
        public_information: '',
        information: '',
        country: '',
        country_code: '',
        email: '',
        web_page: '',
        phone: '',
        phone_2: '',
        fax: '',
        fax_2: '',
        sales_id: null,
        sales2_id: null,
        grade: '0',
        evaluation: '',
        source: '',
        note: '',
        director_remark: '',
        type_1: '',
        type_2: '',
        classes: []
      },
      sourceList: [
        'IC Net web',
        'Hua Qiang web',
        'The broker forum',
        'Net component',
        'IC Source',
        'Allparts',
        'HK Inventory',
        'QQ Group',
        'Skype',
        'Facebook',
        'By vendor/customer',
        'By friend',
        'sales change company',
        'Cys web requirment',
        'internat search',
        'Alibaba',
        'Taobao',
        'By email',
        'By collegue',
        'Exhibition',
        'unkown'
      ]
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    },
    countries () {
      return this.$store.state.select.countries
    },
    salesList () {
      return this.$store.state.select.sales
    },
    showPrivate () {
      return this.user.role_id < 3 || this.user.id === this.company.sales_id || this.user.id === this.company.sales2_id
    },
    categoryList () {
      return this.$store.state.select.category
    }
  },
  mounted () {
    this.form.sales_id = this.user.id || null
    if (this.$route.params.id !== 'new') {
      this.fetchCompany()
    }
    this.$store.dispatch('fetchSelect', 'sales')
    this.$store.dispatch('fetchSelect', 'countries')
    this.$store.dispatch('fetchSelect', 'category')
  },
  methods: {
    fetchCompany () {
      this.$http.get('/dbapi/company_list?id=' + this.$route.params.id).then(data => {
        if (data.list.length > 0) {
          this.company = data.list[0]
          this.company.classes = JSON.parse(this.company.classes)
          this.form = { ...this.company }
        }
      })
    },
    changeCountry (country) {
      let array = this.countries.filter(r => r.en === country)
      if (array.length > 0) {
        this.form.country_code = array[0].code
      }
    },
    classChange (val) {
      // DRAM 和 Flash IC 同时选中
      /*
      if (val.indexOf(1) >= 0) {
        if (val.indexOf(2) < 0){
          this.form.classes.push(2)
        }
      } else {
        if (val.indexOf(2) >= 0){
          this.form.classes.push(1)
        }
      }
      */
    },
    save () {
      if (!this.form.abbreviation) {
        this.$message({
          type: 'error',
          message: '请输入Abbreviation'
        })
        return
      }
      if (!this.form.country) {
        this.$message({
          type: 'error',
          message: '请选择country'
        })
        return
      }
      if (!this.form.source) {
        this.$message({
          type: 'error',
          message: '请选择company source'
        })
        return
      }
      if (!this.form.type_1) {
        this.$message({
          type: 'error',
          message: '请选择Trade / Factory'
        })
        return
      }
      if (!this.form.type_2) {
        this.$message({
          type: 'error',
          message: '请选择Supplier / Buyer'
        })
        return
      }
      if (this.form.classes.length === 0) {
        this.$message({
          type: 'error',
          message: '请选择Customer Class'
        })
        return
      }
      let url = '/dbapi/company_insert'
      if (this.form.id > 0) {
        url = '/dbapi/company_update'
      }
      let postData = { ...this.form }
      postData.classes = JSON.stringify(postData.classes)
      this.$http.post(url, postData).then(data => {
        if (this.form.id > 0) {
          if (this.form.sales_id != this.company.sales_id || this.form.sales2_id != this.company.sales2_id) {
            this.$http.post('/dbapi/company_sales_change', {
              company_id: this.form.id,
              old_sales_id: this.company.sales_id,
              old_sales2_id: this.company.sales2_id,
              new_sales_id: this.form.sales_id,
              new_sales2_id: this.form.sales2_id
            }).then(data => {
              this.$router.push('/customer/company/' + this.form.id)
            })
          } else {
            this.$router.push('/customer/company/' + this.form.id)
          }
        } else {
          let insertCompanyId = data.insertId
          this.$http.post('/dbapi/company_sales_change', {
            company_id: insertCompanyId,
            old_sales_id: 0,
            old_sales2_id: 0,
            new_sales_id: this.form.sales_id,
            new_sales2_id: this.form.sales2_id
          }).then(data => {
            this.$router.push('/customer/company/' + insertCompanyId)
          })
        }
      }).catch(message => {
        if (message.indexOf('Duplicate entry') === 0) {
          if (message.indexOf('name') > 0) {
            this.$message({
              message: 'Company Name already exists',
              type: 'error'
            })
          } else {
            this.$message({
              message: 'Company Abbreviation already exists',
              type: 'error'
            })
          }
        }
      })
    },
    del () {
      this.$confirm('确定要删除吗?', '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/dbapi/company_del', { id: this.$route.params.id }).then(data => {
          this.$message({
            type: 'success',
            message: 'Deleted.'
          })
          this.$router.replace('/customer/company')
        })
      })
    },
    cancel () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss">
.customer-edit {
  background: #fff;
  font-size: 12px;
  .el-input {
    font-size: 12px;
  }
  .title {
    background: #2a82ff;
    font-size: 14px;
    font-weight: bold;
    padding: 4px;
    color: #ffffff;
  }
  table {
    width: 100%;
    border-spacing: 0;
    background-color: #fff;
    td {
      border-bottom: 1px solid #c3c3c2;
      padding: 2px 4px;
    }
    td.label {
      width: 120px;
      background-color: #ddd;
    }
  }
  .el-checkbox__label {
    padding-left: 4px;
  }
  .hide-input .el-input__inner,.hide-input .el-textarea__inner {
    background-color: yellow;
  }
  .star-good {
    color: #ff9900;
  }
  .star-bad {
    color: #000;
  }
  .el-rate__icon {
    margin-right: 0;
  }
  .el-checkbox-group {
    .el-checkbox+.el-checkbox {
      margin-left: 10px;
    }
  }
}
</style>

